var _path, _rect, _rect2, _path2, _g, _circle, _g2, _circle2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSucessoContaBancaria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.163 0H9.75v14h5.271v60.133c0 5.45 4.424 9.867 9.88 9.867h38.662a9.188 9.188 0 009.187-9.188V6.579A6.582 6.582 0 0066.163 0z",
    fill: "url(#sucesso-conta-bancaria_svg__paint0_linear_2228_36722)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 68.25,
    width: 33.25,
    height: 3.5,
    rx: 1.75,
    fill: "#B6C7D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 57.75,
    width: 33.25,
    height: 3.5,
    rx: 1.75,
    fill: "#B6C7D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.915 0A7.085 7.085 0 0115 7.085V14H1V6.727C1 3.012 4.096 0 7.915 0z",
    fill: "url(#sucesso-conta-bancaria_svg__paint1_linear_2228_36722)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.251,
    filter: "url(#sucesso-conta-bancaria_svg__filter0_f_2228_36722)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.25,
    cy: 66.5,
    r: 17.5,
    fill: "#6F6F6F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 66.5,
    r: 17.5,
    fill: "#e80070"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sucesso-conta-bancaria_svg__filter1_d_2228_36722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.806 61.699a1.367 1.367 0 012.025 0c.516.552.556 1.42.119 2.02l-.12.145-8.59 9.188a1.364 1.364 0 01-1.89.127l-.135-.127-4.296-4.594a1.607 1.607 0 010-2.166 1.364 1.364 0 011.89-.127l.135.127 3.283 3.51 7.579-8.104z",
    fill: "#fff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 31.5,
    r: 19.25,
    fill: "url(#sucesso-conta-bancaria_svg__paint2_linear_2228_36722)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.25 21a1.75 1.75 0 01.204 3.488l-.204.012h-6.563a2.188 2.188 0 00-.223 4.364l.224.011h2.624a5.688 5.688 0 01.323 11.366l-.322.009H37.75a1.75 1.75 0 01-.204-3.488l.204-.012h6.563a2.188 2.188 0 00.223-4.364l-.224-.011h-2.624a5.688 5.688 0 01-.323-11.366l.322-.009h6.563z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.79 17.5a1.75 1.75 0 011.738 1.546l.012.204v3.5a1.75 1.75 0 01-3.488.204l-.012-.204v-3.5c0-.966.784-1.75 1.75-1.75zM42.79 36.75a1.75 1.75 0 011.738 1.546l.012.204V42a1.75 1.75 0 01-3.488.204L41.04 42v-3.5c0-.967.784-1.75 1.75-1.75z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sucesso-conta-bancaria_svg__paint0_linear_2228_36722",
    x1: 72.75,
    y1: 84,
    x2: 72.75,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D6E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EEF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sucesso-conta-bancaria_svg__paint1_linear_2228_36722",
    x1: 1,
    y1: 14,
    x2: 15,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3C5D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sucesso-conta-bancaria_svg__paint2_linear_2228_36722",
    x1: 23.75,
    y1: 12.25,
    x2: 23.75,
    y2: 50.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEDAE6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sucesso-conta-bancaria_svg__filter0_f_2228_36722",
    x: 0.032,
    y: 46.282,
    width: 40.437,
    height: 40.437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.359,
    result: "effect1_foregroundBlur_2228_36722"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sucesso-conta-bancaria_svg__filter1_d_2228_36722",
    x: 9.5,
    y: 59.25,
    width: 19.75,
    height: 16.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.000815457 0 0 0 0 0.563094 0 0 0 0 0.402443 0 0 0 0.272946 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2228_36722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2228_36722",
    result: "shape"
  })))));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/sucesso-conta-bancaria-517cfc080b648f40208f235efeb311e7.svg";
export { SvgSucessoContaBancaria as ReactComponent };